import { useState, useEffect } from 'react';

type ToastType = 'success' | 'error' | 'warning' | 'info';

interface ToastMessage {
  id: number;
  type: ToastType;
  message: string;
}

/** Mostra un toast da qualsiasi punto dell'app */
export function showToast(message: string, type: ToastType = 'success') {
  window.dispatchEvent(new CustomEvent('bop:toast', { detail: { message, type } }));
}

/** Contenitore globale dei toast — montare una sola volta nel root */
export function ToastContainer() {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  useEffect(() => {
    const handler = (e: Event) => {
      const { message, type } = (e as CustomEvent).detail;
      const id = Date.now();
      setToasts(prev => [...prev, { id, message, type }]);
      setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 3500);
    };
    window.addEventListener('bop:toast', handler);
    return () => window.removeEventListener('bop:toast', handler);
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="bop-toast-container">
      {toasts.map(toast => (
        <div key={toast.id} className={`bop-toast bop-toast--${toast.type}`}>
          {toast.message}
        </div>
      ))}
    </div>
  );
}
